import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {TicketCommentTagsActions} from '../store';
import {TicketCommentTagsSelectors} from '../store/selectors';

@Injectable()
export class TicketCommentTagsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadTicketCommentTagsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadTicketCommentTagsDone() {
    return this.store.pipe(
      select(TicketCommentTagsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(TicketCommentTagsActions.ReadTicketCommentTags());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
